__turbopack_context__.v({
  "customPromptField": "PromptMenu-module__aJRhkq__customPromptField",
  "customPromptRow": "PromptMenu-module__aJRhkq__customPromptRow",
  "customPromptTrigger": "PromptMenu-module__aJRhkq__customPromptTrigger",
  "grid": "PromptMenu-module__aJRhkq__grid",
  "header": "PromptMenu-module__aJRhkq__header",
  "headerLabel": "PromptMenu-module__aJRhkq__headerLabel",
  "menu": "PromptMenu-module__aJRhkq__menu",
  "promptButton": "PromptMenu-module__aJRhkq__promptButton",
  "solaIcon": "PromptMenu-module__aJRhkq__solaIcon",
});
